import {
  categoryCurrentPageSelector,
  categoryTotalPagesSelector,
} from '../../../redux/category/selectors';

export default (state) => ({
  totalPages: categoryTotalPagesSelector(state),
  currentPage: categoryCurrentPageSelector(state),
});
